import { Injectable } from '@angular/core'
import { ReceiverNotification } from 'app/shared/models/hubs';
import { Subject } from 'rxjs';


@Injectable()
export class NotificationService {
    unreadCount: Subject<number> = new Subject<number>();
    unReadmessagesCount: Subject<number> = new Subject<number>();
    onOpenNotification: Subject<ReceiverNotification | string> = new Subject<ReceiverNotification | string>();
}